/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  static #STORAGE_KEY_FOR_SECTION = 'viewedProductsForSection';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;
  static #MAX_PRODUCTS_FOR_SECTION = 10;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   */
  static addProduct(productId) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(productId);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    let viewedProductsForSection = this.getProductsForSection();
    viewedProductsForSection = viewedProductsForSection.filter((/** @type {string} */ id) => id !== productId);
    viewedProductsForSection.unshift(productId);
    viewedProductsForSection = viewedProductsForSection.slice(0, this.#MAX_PRODUCTS_FOR_SECTION);

    // 保存できない環境(容量超過・プライベートブラウジング等)でも商品ページの処理を止めない
    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
      localStorage.setItem(this.#STORAGE_KEY_FOR_SECTION, JSON.stringify(viewedProductsForSection));
    } catch {
      // 閲覧履歴は補助機能のため、保存失敗は無視する
    }
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch {
      // 同上
    }
  }

  /**
   * localStorage から商品IDの配列を安全に読み出す。
   * 値が壊れていても閲覧履歴全体が止まらないよう、パース失敗時は空配列に倒す。
   * @param {string} key - The storage key to read.
   * @returns {string[]} The list of viewed products.
   */
  static #readProductIds(key) {
    let raw = null;

    try {
      raw = localStorage.getItem(key);
    } catch {
      // プライベートブラウジング等で localStorage 自体が使えない場合
      return [];
    }

    if (!raw) return [];

    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string' || typeof id === 'number') : [];
    } catch {
      return [];
    }
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return this.#readProductIds(this.#STORAGE_KEY);
  }

  static getProductsForSection() {
    return this.#readProductIds(this.#STORAGE_KEY_FOR_SECTION);
  }
}
